import React from 'react';
import Select from '../../engine/SelectEngine';
import styled from 'styled-components/macro';
import Colors from '../../../internal-components/Colors';
import { InputAdornment, OutlinedInput } from '@material-ui/core';

const ComboDropDown = styled(Select)`
  && {
    background: ${Colors.BACKGROUND_GREY};
    border: 0 !important;
    width: 8rem;
    max-width: initial;
    min-height: 35px;
    padding: 0 0.8em;
    margin: 0 0 0 -13px;
    font-size: 14px;
  }

  input {
    padding: 0.5em 0.8em;
  }

  &:hover {
    border-color: #000;
  }
)`;

const StyledOutlinedInput = styled(OutlinedInput)`
  border-radius: 6px !important;
  height: 37px;
  max-height: 37px;
  padding: 0.8rem;
  width: 100%;
  && input {
    font-size: 14px;
    height: 1.1875em;
    margin: 0;
    padding: 0;
  }
`;

const CurrencyComboFieldView = props => {
  const currencySelectValue =
    props.subFieldValues[props.currencySelectSubFieldIndex];
  const numberValue = props.subFieldValues[props.numberValueSubFieldIndex];
  return (
    <div style={{ position: 'relative' }}>
      <StyledOutlinedInput
        variant="outlined"
        value={numberValue}
        onChange={e => {
          const v = e.target.value.replace(/[^\d.]+/g, '');
          props.setSubFieldValue(props.numberValueSubFieldIndex, v);
        }}
        startAdornment={
          <InputAdornment position="start">
            <ComboDropDown
              searchable
              asyncOptions={props.asyncCurrencyOptions}
              disabled={props.readOnly}
              openMenuOptionParser={props.openMenuOptionParser}
              placeholder={props.placeholder}
              variant="outlined"
              forceNonMobileVersion
              onChange={v => {
                props.setSubFieldValue(props.currencySelectSubFieldIndex, v);
              }}
              value={currencySelectValue}
            />
          </InputAdornment>
        }
        inputProps={{
          readOnly: props.readOnly
        }}
      />
    </div>
  );
};

export default CurrencyComboFieldView;
